<template>
  <div id="app">
    <el-container>
      <el-card class="box-card" shadow="never">
        <el-header>
          <el-row>
            <el-col>
              <el-image :src="require('../assets/img/logo-blanco.png')"></el-image>
            </el-col>
          </el-row>
        </el-header>
        <el-main v-if="blank === 0">
          <el-row justify="center">
            <el-col>
              <el-steps :active="active" finish-status="success" align-center >
                  <el-step title="Términos"></el-step>
                  <el-step title="Acceso"></el-step>
                  <el-step title="Enrolamiento"></el-step>
              </el-steps>
            </el-col>
          </el-row>
          <el-form v-if="active===1" :model="ruleForm" :rules="rules" ref="ruleForm">
            <el-row justify="center">
              <el-col :span="24" :xs="24" :sm="24" :md="{span: 12, offset: 6}" :lg="{span: 12, offset: 6}" :xl="{span: 12, offset: 6}">
                <el-card class="box-card-form1" shadow="always">
                  <el-row style="text-align: justify;">
                    <el-col class="p-text">
                        <p><b>Autoriza el tratamiento de sus datos personales de acuerdo con la finalidad descrita</b></p>
                    </el-col>
                    <el-col>
                      <el-form-item prop="check1" style="text-align: left;">
                        <el-radio-group v-model="ruleForm.check1" size="small">
                          <el-radio label="1" border>Acepto</el-radio>
                          <el-radio label="2" border>No Acepto</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row style="text-align: justify;">
                    <el-col class="p-text">
                        <p> <b>Autoriza el tratamiento de sus datos sensibles</b></p>
                    </el-col>
                    <el-col>
                      <el-form-item prop="check2" style="text-align: left;">
                        <el-radio-group v-model="ruleForm.check2" size="small">
                          <el-radio label="1" border>Acepto</el-radio>
                          <el-radio label="2" border>No Acepto</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row style="text-align: justify;">
                    <el-col class="p-text">
                      <el-link href="/static/AUTORIZACION_DE_INGRESO.pdf" target="_blank" type="primary" :underline="false">Leer Autorización de tratamiento de datos personales <i class="el-icon-view el-icon--right"></i></el-link>
                    </el-col>
                  </el-row>
                  <el-row style="text-align: justify;">
                    <el-col class="p-text">
                      <el-link href="/static/POLITICAS_TRATAMIENTO_DATOS.pdf" target="_blank" type="primary" :underline="false">Leer Política de tratamiento de datos personales <i class="el-icon-view el-icon--right"></i></el-link>
                    </el-col>
                  </el-row>
                </el-card>
              </el-col>
            </el-row>
            <el-button style="margin-top: 12px;" @click.native.prevent="next('ruleForm')" type="success">Continuar</el-button>
          </el-form>
          <el-form v-if="active===2" :model="ruleForm2" :rules="rules" ref="ruleForm2" onsubmit="return false;">
            <el-row justify="center">
              <el-col :span="24" :xs="24" :sm="24" :md="{span: 8, offset: 8}" :lg="{span: 8, offset: 8}" :xl="{span: 8, offset: 8}">
                <el-card class="box-card-form1" shadow="always">
                  <el-row justify="center">
                    <el-col :span="24">
                      <el-form-item label="Ingrese el numero de identificación" prop="identification">
                          <el-input v-model="ruleForm2.identification"  maxlength="12" show-password placeholder="Numero de identificación"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-button style="margin-top: 12px;" @click.native.prevent="next2('ruleForm2')" type="success">Continuar</el-button>
                  <el-button style="margin-top: 12px;" @click.native.prevent="cancel()" type="danger">Cancelar</el-button>
                </el-card>
              </el-col>
            </el-row>
          </el-form>
          <el-form v-if="active===3" ref="ruleForm3" onsubmit="return false;">
            <el-row justify="center">
              <el-col :span="24" :xs="24" :sm="24" :md="{span: 10, offset: 7}" :lg="{span: 8, offset: 8}" :xl="{span: 8, offset: 8}">
                <el-card class="box-card-form1" shadow="always">
                  <el-row justify="center" style="margin-bottom: 15px;">
                    <el-col>
                      <el-steps :active="activeTwo" finish-status="success" align-center >
                          <el-step v-for="st in steps" v-bind:key="st.step"></el-step>
                      </el-steps>
                    </el-col>
                  </el-row>
                  <canvas v-show="vifCanvas" id="photoTaken" ref="canvas" :width="widthMinCanvas" :height="heightMinCanvas"></canvas>
                  <el-row v-if="isCameraOpen" v-show="!isLoading">
                    <video ref="camera" :width="widthVideo" :height="heightVideo" autoplay muted playsinline></video>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="Identificación">
                        <el-input v-model="enroll.identification" :disabled="true"></el-input>
                      </el-form-item>
                      <el-form-item label="Nombre Completo">
                        <el-input v-model="enroll.name" :disabled="true"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-button type="info" icon="el-icon-document-copy" @click="dialogStep = true" circle v-if="maxSteps > 0"></el-button>
                  <el-button id="downloadPhoto" @click.prevent="takePhoto" type="primary" v-if="activeTwo < maxSteps">Continuar</el-button>
                  <el-button id="enrollmentId" @click.prevent="enrollment" type="success" v-else>Enrolar</el-button>
                  <el-button type="warning" icon="el-icon-document-copy" @click="centerDialogVisible = true" circle></el-button>
                </el-card>
              </el-col>
            </el-row>
            <el-dialog :visible.sync="dialogStep" :width="wDialog" center :close-on-click-modal="false" :show-close="false" v-if="maxSteps > 0">
              <el-row style="padding-block: 0% !important;">
                <el-col :span="24">
                  <el-row>
                    <el-result :icon="'success'" style="padding-block: 0% !important;"></el-result>
                  </el-row>
                  <el-row>
                    <h3 style="word-break: normal; text-align: center;">{{dialogContentStep.description}}</h3>
                  </el-row>
                </el-col>
              </el-row>
              <span slot="footer" class="dialog-footer">
                <el-button type="success" @click="dialogStep = false">Continuar</el-button>
              </span>
            </el-dialog>
            <el-dialog title="Instrucciones" :visible.sync="centerDialogVisible" :width="wDialog" center :close-on-click-modal="false" :show-close="false">
              <el-carousel :interval="5000" arrow="always" trigger="click">
                <el-carousel-item>
                  <el-image :src="require('../assets/img/prohibido.png')" :fit="'scale-down'"></el-image>
                </el-carousel-item>
                <el-carousel-item>
                  <el-image :src="require('../assets/img/luz.png')" :fit="'scale-down'"></el-image>
                </el-carousel-item>
              </el-carousel>
              <span slot="footer" class="dialog-footer">
                <el-button type="success" @click="centerDialogVisible = false">Continuar</el-button>
              </span>
            </el-dialog>
            <el-dialog :visible.sync="dialogEnroll" :width="wDialog" center :close-on-click-modal="false" :show-close="false">
              <el-row style="padding-block: 0% !important;">
                <el-col :span="24">
                  <el-row v-if="alertEnroll.status === 200 || alertEnroll.has_photo === 0">
                    <el-result :icon="alertEnroll.icon" style="padding-block: 0% !important;"></el-result>
                  </el-row>
                  <el-row>
                    <h3 style="word-break: normal; text-align: center;">{{alertEnroll.title}}</h3>
                  </el-row>
                  <el-row>
                    <el-image :src="alertEnroll.imageUrl" :fit="'scale-down'" v-show="alertEnroll.has_photo === 1"></el-image>
                  </el-row>
                  <el-row v-show="alertEnroll.text !== '' && alertEnroll.text !== null">
                    <p style="font-size: 20px; word-break: normal; text-align: center;">{{alertEnroll.text}}</p>
                  </el-row>
                </el-col>
              </el-row>
              <span slot="footer" class="dialog-footer">
                <el-button type="success" @click="dialogEnroll = false">Continuar</el-button>
              </span>
            </el-dialog>
          </el-form>
        </el-main>
        <el-main v-else>
          <el-row justify="center">
            <el-col :span="24" :xs="24" :sm="24" :md="{span: 10, offset: 7}" :lg="{span: 8, offset: 8}" :xl="{span: 8, offset: 8}">
              <el-card class="box-card-form2" shadow="always">
                <el-result icon="warning" title="URL insuficiente" subTitle="La URL ingresada no cuenta con los parámetros indicados, verificar y recargar de nuevo la página" v-if="blank === 1">
                  <template slot="extra">
                    <el-button type="primary" @click="reload" size="medium">Recargar</el-button>
                  </template>
                </el-result>
                <el-result icon="error" title="Cámara insuficiente" subTitle="La cámara de su dispositivo no cuenta con los requerimientos mínimos para una excelente captura de imagen, resolución mínima 2 MP (1920x1080)" v-if="blank === 2">
                  <template slot="extra">
                    <el-button type="primary" @click="reload" size="medium">Recargar</el-button>
                  </template>
                </el-result>
                <el-result icon="warning" title="El enlace ha expirado" subTitle="Por favor comunicarse al correo gerenciasemana@basepg.co para generar nuevo enlace" v-if="blank === 3">
                  <template slot="extra">
                    <el-button type="primary" @click="reload" size="medium">Recargar</el-button>
                  </template>
                </el-result>
              </el-card>
            </el-col>
          </el-row>
        </el-main>
      </el-card>
    </el-container>
  </div>
</template>
<script>
import axios from 'axios'
export default {
  name: 'enrollment',
  data () {
    return {
      maxSteps: 1,
      steps: [],
      alertEnroll: {
        imageUrl: '',
        icon: '',
        title: '',
        text: '',
        status: 101
      },
      wDialog: '',
      centerDialogVisible: false,
      dialogEnroll: false,
      dialogStep: false,
      dialogContentStep: {
        description: ''
      },
      days: '',
      nav: '',
      blank: 0, // (0) = EXITOSO, (1) = URL insuficiente, (2) = Camara insuficiente, (3) = Enlace ha expirado
      active: 1,
      activeTwo: 1,
      isCameraOpen: false,
      isPhotoTaken: false,
      isShotPhoto: false,
      isLoading: false,
      widthMinCanvas: '',
      heightMinCanvas: '',
      widthVideo: '',
      heightVideo: '',
      videoMinWidth: '',
      videoMinHeight: '',
      vifCanvas: false,
      enroll: {
        parameters: '',
        identification: '',
        name: '',
        versionSuperaccess: '',
        expirationDate: '',
        park: '',
        control: '',
        date: '',
        codCountry: '',
        shard: ''
      },
      ruleForm: {
        check1: [],
        check2: []
      },
      ruleForm2: {
        identification: ''
      },
      rules: {
        identification: [
          { required: true, message: 'Por favor ingrese correctamente su identificación', trigger: 'blur' },
          { min: 4, max: 12, message: 'La longitud debe ser de 4 a 12', trigger: 'blur' }
        ],
        check1: [
          { required: true, message: 'Por favor seleccione una opción', trigger: 'change' }
        ],
        check2: [
          { required: true, message: 'Por favor seleccione una opción', trigger: 'change' }
        ]
      }
    }
  },
  mounted () {
    this.centerDialogVisible = false
    var url = document.location.href
    var uri = this.splitURL(url)
    if (uri !== '') {
      try {
        var decode = this.b64DecodeUnicode(uri)
      } catch (error) {
        this.blank = 1
        console.log('Error en la decodificacion de la URL: ' + error)
      }
      var splitDecode = decode.split('#')
      this.enroll = {
        parameters: uri,
        identification: splitDecode[0],
        name: splitDecode[1],
        versionSuperaccess: splitDecode[2],
        expirationDate: splitDecode[3],
        park: splitDecode[5],
        control: splitDecode[4],
        date: splitDecode[6],
        codCountry: splitDecode[7],
        shard: splitDecode[8],
        canvas: []
      }
      if (this.enroll.identification === '' && this.enroll.name === '' && this.enroll.versionSuperaccess === '' && this.enroll.expirationDate === '' && this.enroll.park === '' && this.enroll.control === '' && this.enroll.date === '' && this.enroll.codCountry === '' && this.enroll.shard === '') {
        this.blank = 1
      }
      if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i)) {
        this.nav = 'movil'
        this.wDialog = '80%'
      } else if (navigator.userAgent.match(/iPad/i)) {
        this.nav = 'tablet'
        this.wDialog = '50%'
      } else {
        this.wDialog = '30%'
        this.nav = 'desktop'
      }
      //  DESARROLLO
      // axios.post('https://testbiometria.toolcrm.net/api/resolution', { navigator: this.nav })
      // PRODUCCION
      axios.post('https://enrolamiento.toolcrm.net/api/resolution', { navigator: this.nav })
        .then(response => {
          // Medidas del canvas
          this.widthMinCanvas = response.data.canvas_width
          this.heightMinCanvas = response.data.canvas_height
          // Medidas de video
          this.widthVideo = response.data.video_width
          this.heightVideo = response.data.video_height
          // Contrains Video
          this.videoMinWidth = response.data.camera_width
          this.videoMinHeight = response.data.camera_height
          // Dias que expira el link
          this.days = response.data.days
          // Campos para captura de N fotos
          this.steps = response.data.steps
          this.maxSteps = this.steps.length
          // Valores de dialog para step por defecto
          if (this.maxSteps > 0) {
            this.dialogContentStep.description = this.steps[0].description
          }
        }).catch(error => {
          console.error('Error en la peticion', error)
        })
    } else {
      this.blank = 1
    }
  },
  methods: {
    expiredDate () {
      // Se captura la fecha de la autorizacion
      var d = this.enroll.expirationDate.split('-')
      var endD = d[2].split(' ')
      // MM/DD/AAAA
      const dateAuto = new Date(d[1] + '/' + endD[0] + '/' + d[0])
      // Se captura la fecha actual
      var f = new Date()
      var currentDate = new Date(f.getFullYear() + ',' + (f.getMonth() + 1) + ',' + f.getDate())
      // Se calcula la diferencia en tiempo
      var Dif = currentDate.getTime() - dateAuto.getTime()
      // Se calcula la diferencia en dias
      var days = (Math.floor(Dif / (1000 * 24 * 60 * 60))) + 1
      if (days > this.days) {
        this.blank = 3
      }
    },
    reload () {
      location.reload()
    },
    next (formName) {
      this.openFullScreen(true)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.ruleForm.check1 === '1' && this.ruleForm.check2 === '1') {
            this.active++
            this.$notify({
              title: 'Bienvenido',
              message: 'Al micrositio de enrolamiento facial de Superaccess.',
              type: 'success'
            })
          } else {
            this.$notify({
              title: 'Atención',
              message: 'Por favor comunicarse al correo gerenciasemana@basepg.co para solicitar un ingreso que no sea por medio de biometría facial.',
              type: 'warning'
            })
          }
        } else {
          return false
        }
      })
      this.openFullScreen(false)
    },
    next2 (formName) {
      this.openFullScreen(true)
      this.$refs[formName].validate((valid) => {
        // if (true) {
        if (valid) {
          // if (true) {
          if (this.ruleForm2.identification === this.enroll.identification) {
            this.active++
            // this.expiredDate()
            if (this.active === 3 && this.blank === 0) {
              this.dialogStep = true
              this.centerDialogVisible = true
              this.toggleCamera()
            }
          } else {
            this.$notify({
              title: 'Atención',
              message: 'La cédula no coincide',
              type: 'warning'
            })
          }
        } else {
          return false
        }
      })
      this.openFullScreen(false)
    },
    cancel () {
      this.active--
    },
    toggleCamera () {
      if (this.isCameraOpen) {
        this.isCameraOpen = false
        this.isPhotoTaken = false
        this.isShotPhoto = false
        this.stopCameraStream()
      } else {
        this.isCameraOpen = true
        this.createCameraElement()
      }
    },
    createCameraElement () {
      this.isLoading = true
      const constraints = (window.constraints = {
        audio: false,
        video: {
          width: { min: this.videoMinWidth },
          height: { min: this.videoMinHeight }
        }
      })
      navigator.mediaDevices
        .getUserMedia(constraints)
        .then(stream => {
          this.$notify({
            title: 'Ingreso Exitoso',
            type: 'success'
          })
          this.isLoading = false
          this.$refs.camera.srcObject = stream
        })
        .catch(error => {
          this.blank = 2
          // this.blank = 0
          this.isLoading = false
          // alert("May the browser didn't support or there is some errors." + error)
          console.log('Cámara insuficiente: ' + error)
        })
    },
    stopCameraStream () {
      let tracks = this.$refs.camera.srcObject.getTracks()
      tracks.forEach(track => { track.stop() })
    },
    takePhoto () {
      this.openFullScreen(true)
      if (this.activeTwo < this.maxSteps) {
        this.activeTwo++
        var array = this.steps
        var flag = true
        for (let index = 0; index < array.length && flag; index++) {
          const element = array[index]
          if (element.id === this.activeTwo) {
            this.dialogContentStep.description = element.description
            flag = false
          }
        }
        this.dialogStep = true
      }
      if (!this.isPhotoTaken) {
        this.isShotPhoto = true
        const FLASH_TIMEOUT = 50
        setTimeout(() => {
          this.isShotPhoto = false
        }, FLASH_TIMEOUT)
      }
      this.isPhotoTaken = !this.isPhotoTaken
      const context = this.$refs.canvas.getContext('2d')
      context.drawImage(this.$refs.camera, 0, 0, this.widthMinCanvas, this.heightMinCanvas)
      const canvas = document.getElementById('photoTaken').toDataURL('image/jpeg')
        .replace('image/jpeg', 'image/octet-stream')
      this.enroll.canvas.push(canvas)
      this.openFullScreen(false)
    },
    enrollment () {
      this.takePhoto()
      this.openFullScreen(true)
      //  DESARROLLO
      // axios.post('https://testbiometria.toolcrm.net/api/enrollment', {enroll: this.enroll})
      // PRODUCCION
      axios.post('https://enrolamiento.toolcrm.net/api/enrollment', {enroll: this.enroll})
        .then(response => {
          this.alertEnroll.status = response.data.status
          this.alertEnroll.icon = response.data.status === 200 ? 'success' : response.data.has_photo === 0 ? 'warning' : ''
          this.alertEnroll.title = response.data.title
          this.alertEnroll.text = response.data.message
          this.alertEnroll.imageUrl = response.data.dir_photo
          this.alertEnroll.has_photo = response.data.has_photo
          if (response.data.status !== 200) {
            if (this.maxSteps > 0) {
              this.dialogContentStep.description = this.steps[0].description
              this.activeTwo = 1
            }
            this.enroll.canvas = []
            this.dialogEnroll = true
            console.log(response.data.console)
          } else {
            this.$notify({
              title: response.data.title,
              message: response.data.message,
              type: 'success'
            })
            window.location.href = 'https://superaccess.com.co/'
          }
        }).catch(error => {
          if (this.maxSteps > 0) {
            this.dialogContentStep.description = this.steps[0].description
            this.activeTwo = 1
          }
          this.enroll.canvas = []
          this.$notify({
            title: 'Enrolamiento fallido',
            message: 'Por favor comunicarse con la mesa de ayuda soporte@superaccess.co',
            type: 'Info'
          })
          console.error('Error de enrolamiento: ', error)
        }).finally(() => {
          this.openFullScreen(false)
        })
    },
    splitURL (str) {
      var validate = false
      var replaceEqual = ''
      if (str.indexOf('?') > 0) {
        var initial = str.split('=')[1]
        replaceEqual = initial.replace(new RegExp('-', 'g'), '=')
        for (var i = 0; i < initial.length && !validate; i++) {
          if (initial[i] === '%') {
            console.log('URL con %')
            validate = true
            replaceEqual = ''
          }
        }
      } else {
        console.log('No envio parametros')
      }
      return replaceEqual
    },
    b64DecodeUnicode (str) {
      return decodeURIComponent(atob(str).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
      }).join(''))
    },
    openFullScreen (state) {
      if (state) {
        this.loading = this.$loading({
          lock: state,
          text: 'Cargando...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
      } else {
        this.loading.close()
      }
    },
    downloadImage () {
      const download = document.getElementById('downloadPhoto')
      const canvas = document.getElementById('photoTaken').toDataURL('image/jpeg')
        .replace('image/jpeg', 'image/octet-stream')
      download.setAttribute('href', canvas)
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .box-card {
    width: 100%;
    align-content: center;
    margin: 0 auto;
    background-color: rgba(245, 245, 245, 0);
    border: none !important;
  }
  .box-card-form1 {
    width: 100%;
    margin-top: 15px !important;
    align-content: center;
    margin: 0 auto;
    background-color: rgba(245, 245, 245, .4);
  }
  .box-card-form2 {
    width: 100%;
    margin-top: 30px !important;
    align-content: center;
    margin: 0 auto;
    background-color: rgba(245, 245, 245, .7);
  }
  body > .el-container {
    margin-bottom: 40px;
  }
  .el-header, .el-footer {
    text-align: center;
  }
  .el-row {
    margin-bottom: 0px;
    margin-top: 5px;
  }
  .el-col {
    border-radius: 4px;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }
  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }
  .el-form-item__content {
    line-height: 15px !important;
  }
  .el-form-item__error {
    color: #ff0000 !important;
    font-size: 12px !important;
  }
  .el-select-dropdown__item {
    color: #000000 !important;
    font-weight: bold !important;
  }
  .el-table {
    font-weight: bold !important;
    color: #000000;
  }
  .el-radio.is-bordered.is-checked {
    border-color: #0303b5 !important;
 }
  >>> .el-radio__input.is-checked+.el-radio__label {
      color: #0303b5 !important;
  }
  .el-radio.is-bordered {
    border: 1px solid #000000 !important;
  }
  .el-radio {
    color: #000000 !important;
  }
  .p-text {
    color: #000000 !important;
  }
  .el-link.el-link--primary {
    color: #0303b5 !important;
  }
  .el-link.el-link--primary:hover {
    color: #0303b5 !important;
    font-weight: bold !important;
  }
  .el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
</style>



// WEBPACK FOOTER //
// src/components/Enrollment.vue